import { withInstall } from '../../utils/with-install.mjs';
import './src/input2.mjs';
export { inputEmits, inputProps } from './src/input.mjs';
import script from './src/input.vue_vue_type_script_lang.mjs';

const ElInput = withInstall(script);

export { ElInput, ElInput as default };
//# sourceMappingURL=index.mjs.map
